/* eslint-disable jsx-a11y/control-has-associated-label */
import BaseSelectBox from 'components/atoms/base-select-box';
import PropTypes from 'prop-types';

const SelectInput = ({
  id,
  title,
  setValue,
  values,
  isRequired,
  disabled,
  requiredIf,
  choices,
  helpText,
}) => {
  let required = isRequired;
  if (requiredIf) {
    required = isRequired || values[requiredIf.key] === requiredIf.value;
  }

  return (
    <div className="input-wrapper" data-cy={id}>
      <label htmlFor={id}>
        {title} {required && <span className="color-red">*</span>}
        {helpText && <p className="help-text">{helpText}</p>}
      </label>
      <BaseSelectBox
        id={id}
        placeholder=""
        disabled={disabled}
        value={values[id]}
        onChange={(v) => {
          setValue({ [id]: v });
        }}
        style={{
          height: '32px',
        }}
        options={choices.map((v) => ({
          label: v,
          value: v,
        }))}
      />
    </div>
  );
};

SelectInput.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  helpText: PropTypes.string,
  choices: PropTypes.array,
  setValue: PropTypes.func,
  isRequired: PropTypes.bool,
  requiredIf: PropTypes.object,
  disabled: PropTypes.bool,
  values: PropTypes.shape(),
};

export default SelectInput;
